import { render, staticRenderFns } from "./searchBanner.vue?vue&type=template&id=fd874960&"
import script from "./searchBanner.vue?vue&type=script&lang=js&"
export * from "./searchBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports